import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useTracking } from "react-tracking";
import { setSubscriptionStoreAction } from "Root/profile/redux/actionCreators/makeActionCreator";
import { fetchUserAccountThunk } from "Root/profile/redux/thunkCreators/accountSettings/accountSettingsThunk";
import { LoadFutureOrdersThunk } from "Root/profile/redux/thunkCreators/orders/futureOrders";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
import LoadMissingAddonsThunk from "Root/profile/redux/thunkCreators/products/missingAddons";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import { SubscriptionV2 } from "Root/profile/utils/trackingEnums";
const useSubscriptionPage = () => {
    const { nav_visibility } = useSelector((state) => state.components);
    const [loading, setLoading] = useState(true);
    const [isEdit, setIsEdit] = useState(false);
    const [accordeonState, setAccordeonState] = useState({
        summary: true,
        future_orders: false,
        billing: false,
    });
    const history = useHistory();
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.subscription);
    const { trackEvent } = useTracking();
    const trackEditBox = () => {
        trackEvent({
            funComponent: SubscriptionV2.Edit_box,
            event: `${SubscriptionV2.Edit_box}`,
        });
    };
    const trackCancelSubscription = () => {
        trackEvent({
            funComponent: SubscriptionV2.Subscription,
            event: `${SubscriptionV2.Cancel_subscription}__page=subscription`,
        });
    };
    const onChangeIsEdit = (value) => {
        value && trackEditBox();
        setIsEdit(value);
    };
    const dispatch = useDispatch();
    const toggleAccordion = (field) => {
        const value = !accordeonState[field];
        setAccordeonState({
            ...accordeonState,
            [field]: value,
        });
    };
    const fetchAllData = async () => {
        setLoading(true);
        await Promise.all([
            dispatch(LoadUserCartThunk()),
            dispatch(LoadPricingThunk()),
            dispatch(LoadFutureOrdersThunk()),
            dispatch(fetchUserAccountThunk()),
            dispatch(LoadMissingAddonsThunk()),
        ]);
        setLoading(false);
    };
    useEffect(() => {
        if (reduxStoreIsEmpty) {
            fetchAllData();
            dispatch(setSubscriptionStoreAction(false));
        }
        else {
            setLoading(false);
        }
        const product = history.location.hash.replace("#", "");
        if (["protein", "hydration", "preworkout", "creatine", "fiber", "collagen"].includes(product)) {
            setIsEdit(true);
        }
        if (product === "future_orders") {
            setAccordeonState({
                summary: false,
                future_orders: true,
                billing: false,
            });
        }
    }, []);
    return {
        loading,
        toggleAccordion,
        nav_visibility,
        isEdit,
        setIsEdit: onChangeIsEdit,
        accordeonState,
        trackCancelSubscription,
    };
};
export default useSubscriptionPage;
